import { useNavigate } from 'react-router-dom';

const useNavigation = () => {
    const navigate = useNavigate();

    const navigateToSection = (sectionId) => {
        navigate('/');
        setTimeout(() => {
            const section = document.getElementById(sectionId);
            if (section) {
                window.scrollTo({
                    top: section.offsetTop - 75,
                    behavior: 'smooth',
                });
            }
        }, 100);
    };

    return navigateToSection;
};

export default useNavigation;
